module.exports = "/_next/static/images/7186240a346b5e5c41032bb22fd1b1f6-card-icon.svg.webp";